// extracted by mini-css-extract-plugin
export var container = "_a2-0";
export var icon = "_a2-1";
export var text = "_a2-2";